import { render } from "./PartnerManageCreatePage.vue?vue&type=template&id=382d2125&lang=true"
import script from "./PartnerManageCreatePage.vue?vue&type=script&lang=js"
export * from "./PartnerManageCreatePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__